import { StyledPropType } from 'style-utils/core/core.types';
import { createExtractCssFromProps } from 'style-utils/core/createExtractCssFromProps/createExtractCssFromProps';
import { Theme } from 'style-utils/theme';
import { CSSProperties } from 'styled-components';

export const backgroundxMappedProps = {
  bg: {
    property: 'background',
    themeKey: 'colors',
  },
  bgColor: {
    property: 'backgroundColor',
    themeKey: 'colors',
  },
  bgImage: { property: 'backgroundImage' },
  bgSize: { property: 'backgroundSize' },
  bgPosition: { property: 'backgroundPosition' },
  bgRepeat: { property: 'backgroundRepeat' },
};

export type WithBackgroundProps = {
  bg?: StyledPropType<keyof Theme['colors']>;
  bgColor?: StyledPropType<CSSProperties['backgroundColor']>;
  bgImage?: StyledPropType<CSSProperties['backgroundImage']>;
  bgSize?: StyledPropType<CSSProperties['backgroundSize']>;
  bgPosition?: StyledPropType<CSSProperties['backgroundPosition']>;
  bgRepeat?: StyledPropType<CSSProperties['backgroundRepeat']>;
};

export const withBackground = createExtractCssFromProps(backgroundxMappedProps);
